// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AiOnboardingModal_AiSuggestionFragment, AiOnboardingModal_AiSuggestionFormDataFragment, AiOnboardingModal_HouseholdFragment } from '../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import { gql } from '@apollo/client';
import { AiOnboardingModal_AiSuggestionFragmentDoc, AiOnboardingModal_AiSuggestionFormDataFragmentDoc, AiOnboardingModal_HouseholdFragmentDoc } from '../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchAiSuggestionsForReviewCardV2QueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type FetchAiSuggestionsForReviewCardV2Query = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, newIndividualsAutomaticallyOnboardedAt?: Time | null } | null } | null> | null }, aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', id: string }
        & AiOnboardingModal_AiSuggestionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchAISuggestionsForReviewCardV2: 'FetchAISuggestionsForReviewCardV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchAiSuggestionsForReviewCardV2Document = gql`
    query FetchAISuggestionsForReviewCardV2($householdID: ID!) {
  households(where: {id: $householdID}) {
    edges {
      node {
        id
        newIndividualsAutomaticallyOnboardedAt
      }
    }
  }
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdID}], kindIn: [ONBOARDING_ENTITY, ONBOARDING_TESTAMENTARY_ENTITY], acceptanceStatusIsNil: true}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        id
        ...AIOnboardingModal_AISuggestion
      }
    }
  }
}
    ${AiOnboardingModal_AiSuggestionFragmentDoc}`;

/**
 * __useFetchAiSuggestionsForReviewCardV2Query__
 *
 * To run a query within a React component, call `useFetchAiSuggestionsForReviewCardV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchAiSuggestionsForReviewCardV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAiSuggestionsForReviewCardV2Query({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useFetchAiSuggestionsForReviewCardV2Query(baseOptions: Apollo.QueryHookOptions<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>(FetchAiSuggestionsForReviewCardV2Document, withFetchPolicyContext(options));
      }
export function useFetchAiSuggestionsForReviewCardV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>(FetchAiSuggestionsForReviewCardV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchAiSuggestionsForReviewCardV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>(FetchAiSuggestionsForReviewCardV2Document, withFetchPolicyContext(options));
        }
export type FetchAiSuggestionsForReviewCardV2QueryHookResult = ReturnType<typeof useFetchAiSuggestionsForReviewCardV2Query>;
export type FetchAiSuggestionsForReviewCardV2LazyQueryHookResult = ReturnType<typeof useFetchAiSuggestionsForReviewCardV2LazyQuery>;
export type FetchAiSuggestionsForReviewCardV2SuspenseQueryHookResult = ReturnType<typeof useFetchAiSuggestionsForReviewCardV2SuspenseQuery>;
export type FetchAiSuggestionsForReviewCardV2QueryResult = Apollo.QueryResult<FetchAiSuggestionsForReviewCardV2Query, FetchAiSuggestionsForReviewCardV2QueryVariables>;